import { metaAdapter } from "../adapters/metaAdapter";
import AdsTemplateTable from "../common/AdsTemplateTable";
import CreateMetaTemplateView from "./CreateMetaTemplateView";

export default function MetaTemplateTable() {
  return <AdsTemplateTable adapter={metaAdapter} EditDialog={CreateMetaTemplateView} />;
}
